import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { AIOverview } from '../generic-notes/AIOverview';
import { IRecording } from '../../recording/RecordingState';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { ClipboardIcon } from '../../theme/Icons';
import { INote } from '../generic-notes/INote';

export const Overview: FC<{ note: ICaremapNoteResponse | INote; }> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;
    return recording?.summary?.highLevelSummary && (
        <ViewNoteSection title="Overview" Icon={ClipboardIcon} showAIIcon>
            <AIOverview recording={recording} />
        </ViewNoteSection>
    );
};
